import Footer from "../Homepages/Footer";
import { BsArrowLeft, BsPlusCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setTask, setCompleted } from "../../reducers/userReducer";
import SortTodo from "./SortTodo";
import CompletedTodo from "./CompletedTodo";
import { clearTasks } from "../../reducers/userReducer";

export default function Todos() {
  let keyId = 1;
  const navigate = useNavigate();
  const tasks = useSelector(setTask);
  const completed = useSelector(setCompleted);
  const dispatch = useDispatch();
  let reset = (
    null
  )
  if(completed.length > 0){
    reset = (
      <button className="btnS" onClick={()=>{dispatch(clearTasks())}}>Clear</button>
    )
  }
  return (
    <div className="container px-4 px-md-5 position-relative">
      <div className="heading mb-3 mt-5">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/enterTodo");
          }}
        />
        <h3 className="text-center no-wrap">My Planner</h3>
      </div>
      <div className="mb-4">
        <h2 style={{ fontWeight: "bold" }}>Upcoming Tasks</h2>
      </div>
      {tasks.map(
        (task) =>(
          <SortTodo task={task} key={keyId++}/>
        )
      )}
      <div className="my-4">
        <h2 style={{ fontWeight: "bold" }}>Completed</h2>
      </div>
      {completed.map(
        (complete) =>(
          <CompletedTodo complete={complete} key={keyId++}/>
        )
      )}
      {reset}
      <BsPlusCircleFill
        color="#F39237"
        size="40px"
        className="arro"
        style={{ cursor: "pointer" }}
        onClick={() => {
          navigate("/enterTodo");
        }}
      />
      <Footer />
    </div>
  );
}
